<template>
    <div class="visitor-page">
        <div class="header">{{ $vuetify.lang.t('$vuetify.visitor.visitor') }}</div>

        <div class="sub-header">
            <div class="search-container">
                <v-text-field
                    class="search-box"
                    v-model="search"
                    prepend-inner-icon="search"
                    :placeholder="$vuetify.lang.t('$vuetify.visitor.searchBy')"
                    solo
                    height="40"
                    @keyup.enter="getVisitorDatatable()">
                </v-text-field>

                <v-btn
                    class="ml-3"
                    @click="searchVisitor()"
                    color="primary"
                    outlined
                    height="40">
                    {{ $vuetify.lang.t('$vuetify.visitor.search') }}
                </v-btn>

                <v-select
                    class="ml-12"
                    @change="getVisitorDatatable()"
                    v-model="visitorStatus"
                    item-text="text"
                    item-value="value"
                    :items="visitorStatusDropdown"
                    outlined
                    height="40"
                    background-color="#ffffff">
                </v-select>
            </div>

            <v-btn
                v-if="permissionCreate"
                @click="createVisitor()"
                height="40"
                color="primary">
                + {{ $vuetify.lang.t('$vuetify.visitor.createNewVisitor') }}
            </v-btn>
        </div>

        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                @click:row="viewVisitor"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="total"
                :items="items"
                :loading="loading">
                <template v-slot:[`item.status`]="{ item }">
                    <div :class="getStatusStyle(item.status)">{{ item.status }}</div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action">
                        <v-icon
                            v-if="permissionUpdate"
                            class="mr-2"
                            @click.stop="updateVisitor(item.id)">
                            edit
                        </v-icon>
                        <v-icon
                            v-if="permissionDelete"
                            class="mr-2"
                            @click.stop="openModalDelete(item)">
                            delete
                        </v-icon>
                    </div>
                </template>
            </v-data-table>
        </v-card>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deleteSuccess()"
            :deleteForm="deleteForm"/>

    </div>
</template>

<script>
import permissionConstant from '@/constants/permissions.js'
import DeleteModal from '@/components/modal/DeleteModal'

export default {
    name: 'Visitor',

    components: {
        DeleteModal
    },
    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.visitor.visitorName'), value: 'person__fullname', width: '23%' },
                { text: this.$vuetify.lang.t('$vuetify.visitor.contact'), value: 'person__email', width: '18%' },
                { text: this.$vuetify.lang.t('$vuetify.visitor.contactNo'), value: 'person__phone_no', width: '18%' },
                { text: this.$vuetify.lang.t('$vuetify.visitor.joinedDate'), value: 'created_at', width: '16%' },
                { text: this.$vuetify.lang.t('$vuetify.visitor.status'), value: 'status', width: '15%' },
                { text: '', value: 'action', width: '10%', sortable: false }
            ]
        },
        questionDelete () {
            return this.$vuetify.lang.t('$vuetify.visitor.questionDelete')
        },
        msgDeleteSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.visitor.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.visitor.msgDeleteSuccess'),
                type: 'success'
            }
        },
        visitorStatusDropdown () {
            const item = this.visitorStatusItem
            // add all status to first data
            item.unshift({
                text: this.$vuetify.lang.t('$vuetify.visitor.allStatus'),
                value: null
            })
            return item
        }
    },
    data () {
        return {
            branchId: null,

            // search and filter
            search: null,
            visitorStatus: null,
            visitorStatusItem: [],

            // datatable
            pageCount: 1,
            page: 1,
            options: {},
            total: 0,
            items: [],
            loading: false,

            // permissions
            permissionCreate: false,
            permissionUpdate: false,
            permissionDelete: false,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            }
        }
    },

    methods: {
        async getVisitorStatus () {
            const res = await this.axios.get('visitor/status')
            if (res && res.data && res.data.status === 'ok') {
                this.visitorStatusItem = res.data.data
            }
        },

        async searchVisitor () {
            this.options.page = 1
            await this.getVisitorDatatable()
        },

        async getVisitorDatatable () {
            if (!this.branchId) {
                return
            }

            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `visitors?branch=${this.branchId}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.visitorStatus) {
                url += `&status=${this.visitorStatus}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.items = res.data.data
                this.total = res.data.total
            }

            this.checkPermission()
            this.loading = false
        },

        viewVisitor (visitor) {
            this.$router.push({ name: 'VisitorHistory', params: { id: visitor.id } })
        },

        createVisitor () {
            this.$router.push({ name: 'VisitorForm' }, () => {})
        },

        updateVisitor (id) {
            this.$router.push({ name: 'VisitorForm', params: { id } })
        },

        getStatusStyle (status) {
            let style = 'status-label'
            if (status === 'Active') {
                style += ' active'
            } else if (status === 'Deactive') {
                style += ' deactive'
            } else if (status === 'ใช้งาน') {
                style += ' active'
            } else if (status === 'ปิดการใช้งาน') {
                style += ' deactive'
            }

            return style
        },

        checkPermission () {
            this.permissionCreate = this.$util.checkPermission(permissionConstant.visitor.create)
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.visitor.update)
            this.permissionDelete = this.$util.checkPermission(permissionConstant.visitor.delete)
        },

        openModalDelete (visitor) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.visitor.deleteVisitor')
            this.deleteForm.content = this.questionDelete.replace('$Name', visitor.person__fullname)
            this.deleteForm.path = `visitor/delete/${visitor.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deleteSuccess () {
            await this.getVisitorDatatable()
            this.$notify(this.msgDeleteSuccess)
        }
    },

    async mounted () {
        this.branchId = localStorage.getItem('currentBranchId')
        await this.getVisitorStatus()
        await this.getVisitorDatatable()
    },

    watch: {
        options: {
            async handler () {
                if (this.branchId) {
                    await this.getVisitorDatatable()
                }
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getVisitorDatatable()
                await this.getVisitorStatus()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-box {
    width: 340px;

    .v-input__control > .v-input__slot {
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
    }
}

::v-deep .v-input__append-inner {
    margin-top: 12px;
}

::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee;
    cursor: pointer;
}

.header {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}

.sub-header {
    display: flex;
    justify-content: space-between;

    .search-container {
        display: flex;
        justify-content: flex-start;

        & > div {
            display: inline-block;
        }
    }
}

.status-label {
    border-radius: 15px;
    color: white;
    width: 100px;
    text-align: center;

    &.active {
        background-color: #139888;
    }

    &.deactive {
        background-color: #ff544a;
    }
}
</style>
